import documentInit from './modules/document';
import mobileNavInit from './modules/mobile-nav';
import slickInit from './modules/slick';
import miscInit from './modules/misc';
import projectFilterInit from './modules/project-filter';

(function ($) {

	$(document).on('afterLoad.fb', function (e, instance, slide) {
		slide.$slide.closest('.fancybox-container').find('[data-fancybox-close]').fadeIn();
	});

	$(document).ready(function () {

		documentInit();
		mobileNavInit();
		slickInit();
		miscInit();
		projectFilterInit();

		$(window).trigger('scroll');

	});

})(jQuery);